import { Component, DestroyRef, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { AuctionManageService } from '../../services/auction-manage/auction-manage.service';
import { Store, select } from '@ngrx/store';
import { selectCurrentAuction } from '../../features/auction.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-auction-search-by-bidder',
  templateUrl: './auction-search-by-bidder.component.html',
  styleUrls: ['./auction-search-by-bidder.component.scss']
})
export class AuctionSearchByBidderComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Output() bidderSelected = new EventEmitter<any>();

  public auctionCampaign: any = null;

  public bidderSearch: UntypedFormControl = new UntypedFormControl('', []);
  public isSearchedBidderExists: boolean = true;

  public auctionBidders: any = null;
  public filteredAuctionBidders: any = null;

  public selectedBidder: any = null;

  public currentAuctionCampaign$ = this.store.pipe(
    select(selectCurrentAuction),
  )

  constructor(
    private auctionManageService: AuctionManageService,
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.currentAuctionCampaign$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((auctionCampaign) => {
      this.auctionCampaign = auctionCampaign;
    })
    this.auctionBidders = this.auctionManageService.getAuctionBidders(this.auctionCampaign)
    
    this.filteredAuctionBidders = _.cloneDeep(this.auctionBidders);

    this.bidderSearch.valueChanges.pipe(
      map(search => _.filter(this.auctionBidders, (bidder) => {
        const userInfo = bidder.bidInfo.userInfo
        
        if(!_.includes(userInfo.name.toLowerCase(), search.toLowerCase()) && 
          !_.includes(userInfo.email.toLowerCase(), search.toLowerCase()) ) {
          this.isSearchedBidderExists = false;
        } else {
          this.isSearchedBidderExists = true;
          return true
        }
      })),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(filteredBidders => {
      this.filteredAuctionBidders = _.cloneDeep(filteredBidders);
    }); 
  }

  seeBidderDetails(bidder) {
    this.selectedBidder = _.cloneDeep(bidder);

    this.bidderSelected.emit(this.selectedBidder);
  }

  resetSearch() {
    this.bidderSearch.setValue('');
  }
}
